export enum InvitationStatus {
    Acknowledged = 'ACKNOWLEDGED',
    Pending = 'PENDING',
    NotSupported = 'NOT_SUPPORTED',
    Failed = 'FAILED',
    Expired = 'EXPIRED',
    Canceled = 'CANCELLED',
    CancelFailed = 'CANCEL_FAILED'
}